import { createFileRoute } from "@tanstack/react-router"
import { UserRoundPlus } from "lucide-react"
import { authEmployeeQuery } from "modules/auth/lib/authEmployeeQuery"
import { EmployeesTable } from "modules/settings/components/Team/EmployeesTable"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/settings/team")({
  component: EmployeesTable,
  loader: async ({ route: { fullPath }, context }) => {
    const employee = await context.queryClient.fetchQuery(authEmployeeQuery())

    const canInvite = employee.isOwner || employee.isManager

    return new Crumb({
      fullPath,
      title: (t) => t("settings.team.title"),
      actions: (t) =>
        canInvite
          ? [
              {
                id: "invite-employee",
                title: t("settings.team.actions.invite"),
                to: "/settings/team/invite",
                icon: UserRoundPlus,
              },
            ]
          : [],
    })
  },
})
